import React from "react"

const Emiratus=()=>{
   return (
     <h1>Emiratus</h1>
   )
}

export default Emiratus